"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInLoginButton = void 0;
var LinkedInLoginButton_1 = require("./LinkedInLoginButton");
Object.defineProperty(exports, "LinkedInLoginButton", { enumerable: true, get: function () { return LinkedInLoginButton_1.LinkedInLoginButton; } });
